import { useEffect, useMemo } from 'react';
import useWaterMarker from '@/hooks/useWaterMarker';
import { connect } from 'react-redux';

interface propsType {
  erp: string;
}

function extraStyle() {
  return {
    position: 'fixed',
    left: '100px',
    top: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 990,
  };
}

function WaterMakerInner(props: propsType) {
  const dom = useMemo(() => {
    const innerDom = document.createElement('div');
    innerDom.className = 'full-size-water-maker';
    innerDom.id = 'fullSizeWaterMaker';
    return innerDom;
  }, []);

  useEffect(() => {
    const targetNode = document.body;

    // 观察器的配置（需要观察什么变动）
    const config = { attributes: false, childList: true, subtree: false };

    const callback = function (mutationsList: any) {
      for (const mutation of mutationsList) {
        if (mutation.type !== 'childList') continue;
        if (mutation.removedNodes.length === 0) continue;
        if (!document.getElementById('fullSizeWaterMaker')) {
          observer.disconnect();
          document.body.appendChild(dom);
          // document.body.innerHTML = "你的行为已上报，24H内会有人员联系你";
          observer.observe(targetNode, config);
        }
      }
    };
    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, [dom]);

  useEffect(
    function () {
      document.body.appendChild(dom);

      return () => {
        document.body.removeChild(dom);
      };
    },
    [dom]
  );

  useWaterMarker(props.erp, { current: dom }, extraStyle);

  return null;
}

const WaterMaker = connect((state: any) => {
  return {
    erp: state.userInfo?.userMap?.erp,
  };
})(WaterMakerInner);

export default WaterMaker;
